<template>
  <div class="card" :style="computedStyle">
    <h2 class="card-title">{{ title }}</h2>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class CardItem extends Vue {
  @Prop() title!: string
  @Prop() active!: boolean

  get computedStyle() {
    const y = this.active ? -32 : 0  
    return {
      transform: `translateY(${y}px)`,
      opacity: this.active ? 1 : 0.25,
      transition: "0.35s"    
    }
  }
}
</script>

<style scoped>
.card {
    width: 290px;
    height: 532px;
    color: white;
    background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
}

.card-title {
  font-size: 20px;
  font-weight: 700; 
  letter-spacing: -0.01em;
  text-align: left;
  margin-bottom: 5px;  
}

.line {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  white-space: pre;
}

.line span {
  flex: 1;  
}

</style>